<div
  style="
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin: 0px 0px -10px 0;
  "
>
  <h3 *ngIf="data.action == 'add'" mat-dialog-title>
    <strong> Asociar Equipos</strong>
  </h3>
  <div
    style="
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    "
    class="mat-elevation-z3"
    (click)="dialogRef.close()"
  >
    <i class="fa fa-times"></i>
  </div>
</div>

<div
  style="
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    overflow: auto;
  "
>
  <div style="width: 100%; margin-top: 30px">
    <data-table
      [columns]="columnsE"
      [url]="EndpointDictionary.Equipment.EQUIPMENT_MISSING_BY_FORM_TABLE"
      [configuration]="configurationE"
      [reloadTable]="reloadTableE"
      [params]="paramsEquipment"
      (selected)="selectedEquipment($event)"
      
    >
    </data-table>
  </div>
  <button
    style="width: 70%; margin-top: 15px"
    color="primary"
    class="button-save mat-elevation-z5"
    (click)="finalizar()"
    mat-raised-button
  >
    Aceptar
  </button>
</div>
